import React from "react";
import {
  Dialog,
  Button,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./PreviewFormPopup.module.css";
import CountryCodePhoneInput from "../../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import CancelBtn from "../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import FieldFileDropZone from "../../../../../../components/FileDropZone/FieldFileDropZone";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NewFormTextInput from "../../../../../../components/FormTextInput/NewFormTextInput";

const PreviewFormPopup = (props: any) => {
  const {
    rightSectionFields,
    showPreviewPopup,
    onClose,
    handleUpdateForm,
    isComingFromNextButton,
    setIscomingFromNextButton,
    updatedButtonName,
    UpdateWebformLoading,
    CreateWebformLoading,
  } = props;

  const handleClose = () => {
    onClose();
    setIscomingFromNextButton(false);
  };

  // const renderPreviewFields = () => {
  //   return rightSectionFields?.map((field: any, index: number) => {
  //     switch (field.fieldType.toLowerCase()) {
  //       case "text":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <div style={{ textTransform: "capitalize", marginBottom: "5px" }}>
  //               {field?.fieldName}
  //             </div>

  //             <TextField
  //               fullWidth
  //               placeholder="Enter your answer"
  //               variant="outlined"
  //               inputProps={{
  //                 style: {
  //                   padding: "8px 12px",
  //                 },
  //               }}
  //               disabled
  //             />
  //           </Box>
  //         );
  //       case "email":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <div style={{ textTransform: "capitalize", marginBottom: "5px" }}>
  //               {field?.fieldName}
  //             </div>

  //             <TextField
  //               fullWidth
  //               placeholder="Enter your answer"
  //               disabled
  //               variant="outlined"
  //               inputProps={{
  //                 style: {
  //                   padding: "8px 12px",
  //                 },
  //               }}
  //             />
  //           </Box>
  //         );
  //       case "select":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <div style={{ textTransform: "capitalize", marginBottom: "5px" }}>
  //               {field?.fieldName}{" "}
  //               <span style={{ color: "red" }}>
  //                 {field?.required ? "*" : ""}
  //               </span>
  //             </div>

  //             <FormControl
  //               fullWidth
  //               key={index}
  //               margin="normal"
  //               sx={{ marginTop: 0 }}
  //             >
  //               <Select
  //                 MenuProps={{
  //                   style: { zIndex: 999999, fontSize: "14px" },
  //                   PaperProps: {
  //                     style: {
  //                       boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
  //                     },
  //                   },
  //                 }}
  //               >
  //                 {field.options?.map((option: any) => (
  //                   <MenuItem key={option.id} value={option.name}>
  //                     {option.name}
  //                   </MenuItem>
  //                 ))}
  //               </Select>
  //             </FormControl>
  //           </Box>
  //         );
  //       case "phone":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <div style={{ textTransform: "capitalize", marginBottom: "5px" }}>
  //               {field?.fieldName}
  //             </div>

  //             <CountryCodePhoneInput error={true} disabled={true} />
  //           </Box>
  //         );

  //       case "radio":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <FormControl component="div">
  //               <div
  //                 style={{ textTransform: "capitalize", marginBottom: "5px" }}
  //               >
  //                 {field?.fieldName}
  //               </div>
  //               <RadioGroup
  //                 aria-label={field?.fieldName}
  //                 name={field?.fieldName}
  //               >
  //                 {field.options?.map((option: any) => (
  //                   <FormControlLabel
  //                     key={option.id}
  //                     label={option.name}
  //                     value={option.name}
  //                     control={
  //                       <Radio size="small" inputProps={{ readOnly: true }} />
  //                     }
  //                   />
  //                 ))}
  //               </RadioGroup>
  //             </FormControl>
  //           </Box>
  //         );

  //       case "checkbox":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <FormControl component="fieldset">
  //               <div
  //                 style={{ textTransform: "capitalize", marginBottom: "5px" }}
  //               >
  //                 {field?.fieldName}
  //               </div>
  //               <FormGroup>
  //                 {field.options?.map((option: any) => (
  //                   <FormControlLabel
  //                     key={option.id}
  //                     control={<Checkbox />}
  //                     label={option.name}
  //                   />
  //                 ))}
  //               </FormGroup>
  //             </FormControl>
  //           </Box>
  //         );
  //       case "date":
  //         return (
  //           <Box key={index} sx={{ marginBottom: 2, width: "100%" }}>
  //             <div style={{ textTransform: "capitalize", marginBottom: "5px" }}>
  //               {field?.fieldName}
  //             </div>

  //             <TextField
  //               fullWidth
  //               placeholder={"--/--/----"}
  //               variant="outlined"
  //               inputProps={{
  //                 style: {
  //                   padding: "8px 12px",
  //                 },
  //               }}
  //               disabled
  //             />
  //           </Box>
  //         );
  //       default:
  //         return null;
  //     }
  //   });
  // };

  const capitalizeSentences = (text: string) => {
    let lowercasedText = text.toLowerCase();

    let capitalizedText = lowercasedText.replace(
      /(^\s*\w|[\.\!\?]\s*\w)/g,
      function (match) {
        return match.toUpperCase();
      }
    );

    return capitalizedText;
  };

  const renderField = (field: any) => {
    switch (field.fieldType) {
      case "text":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <NewFormTextInput variant="standard" fullWidth disabled />
          </div>
        );
      case "email":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <NewFormTextInput variant="standard" fullWidth disabled />
          </div>
        );

      case "phone":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <CountryCodePhoneInput error={true} disabled />
          </div>
        );

      case "radio":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FormControl component="fieldset" key={field.id} disabled>
              <RadioGroup value={field.fieldValue || ""}>
                {field?.options?.map((option: any) => (
                  <FormControlLabel
                    key={option.id}
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          strokeWidth: 1,
                          color: "#D0D5DD",
                        }}
                      />
                    }
                    label={
                      <div
                        style={{
                          fontSize: "13PX",
                          textTransform: "capitalize",
                        }}
                      >
                        {option?.name}
                      </div>
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        );

      case "date":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <LocalizationProvider dateAdapter={AdapterDayjs} key={field.id}>
              <DesktopDatePicker
                sx={{
                  zIndex: "99999999 !important",
                  width: "100%",
                  fontSize: "14px",
                  "& .MuiOutlinedInput-input": {
                    fontSize: "14px",
                    color: "#142C44",
                    padding: "9px",
                  },
                }}
                format="DD/MM/YYYY"
                value={field.fieldValue ? dayjs(field.fieldValue) : null}
                disabled
              />
            </LocalizationProvider>
          </div>
        );

      case "checkbox":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FormControl component="fieldset" key={field.id} disabled>
              {field?.options?.map((option: any) => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      checked={field.fieldValue?.includes(option.id) || false}
                      sx={{
                        strokeWidth: 1,
                        color: "#D0D5DD",
                      }}
                    />
                  }
                  label={
                    <div
                      style={{
                        fontSize: "13PX",
                        textTransform: "capitalize",
                      }}
                    >
                      {option?.name}
                    </div>
                  }
                />
              ))}
            </FormControl>
          </div>
        );

      case "select":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small" disabled>
              <div className={styles.demoFieldLabel}>
                {capitalizeSentences(field.fieldName)}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
              >
                {field?.options?.map((option: any) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    sx={{
                      color: "#667085",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );

      case "COURSE":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small" disabled>
              <div className={styles.demoFieldLabel}>
                {capitalizeSentences(field.fieldName)}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
              >
                {field?.options?.map((option: any) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    sx={{
                      color: "#667085",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );

      case "BRANCH":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small" disabled>
              <div className={styles.demoFieldLabel}>
                {capitalizeSentences(field.fieldName)}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
              >
                {field?.options?.map((option: any) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    sx={{
                      color: "#667085",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );

      case "BATCH":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small" disabled>
              <div className={styles.demoFieldLabel}>
                {capitalizeSentences(field.fieldName)}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
              >
                {field?.options?.map((option: any) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    sx={{
                      color: "#667085",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );

      case "file":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FieldFileDropZone field={field} disabled={true} />
          </div>
        );

      case "profilePic":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.demoFieldLabel}>
              {capitalizeSentences(field.fieldName)}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FieldFileDropZone field={field} disabled={true} />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={showPreviewPopup}
      onClose={onClose}
      sx={{
        zIndex: "99999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          height: "auto",
          maxWidth: "400px",
          minHeight: "165px",
          // padding: "24px",
          borderRadius: "8px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "0",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "24px 24px 10px 24px" }}>
          <div className={styles.closeModalButton}>
            <CloseIcon sx={{ color: "#555555" }} onClick={handleClose} />
          </div>
          <div className={styles.modalTitle}>Preview</div>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "400px",
            padding: "10px 24px 10px 24px",
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            {/* {renderField()} */}

            {rightSectionFields?.map((field: any) => renderField(field))}
          </div>

          <Button
            fullWidth
            variant="outlined"
            sx={{ textTransform: "capitalize", marginBottom: "40px" }}
            disabled
          >
            {updatedButtonName}
          </Button>
        </div>
        {isComingFromNextButton && (
          <div className={styles.previewBtnWrap}>
            <CancelBtn
              onClick={() => {
                handleClose();
                setIscomingFromNextButton(false);
              }}
            />
            <SaveBtn
              buttonText="Publish Form"
              onClick={handleUpdateForm}
              disabled={UpdateWebformLoading || CreateWebformLoading}
              loader={UpdateWebformLoading || CreateWebformLoading}
            />
          </div>
        )}
      </div>
    </Dialog>
  );
};
export default PreviewFormPopup;
